<template>
	<div class="container" aria-label="当前展示的是搜索页面，包括一个搜索框，一个搜索按钮和搜索结果展示区域，当您输入了想要学习的内容，点击搜索后，会展示相关资源的链接，您可以点击对应的链接跳转至学习页面。" tabindex="0">
		<div class="search-area">
			<input  class="search-input" placeholder="搜索你感兴趣的课程" v-model="inputContent" @keydown.enter="toSearch()" />
			<button class="search-button" @click="toSearch()">搜索</button>
		</div>

		<div class="result-list" >
			<div ref="displayArea" v-for="(item, index) in searchResults" :key="index" class="result-item" @click="handleClickItem(index)" @keydown.enter="handleClickItem(index)" role="link" tabindex="0">{{ item.sectionName }}</div>
		</div>
	</div>
</template>

<script>
import {baseUrl, searchCourseUrl} from '@/constants/urls.js';
import axios from 'axios';

export default {
	data () {
		return {
			inputContent: '',
			searchResults: []
		}
	},
	methods: {
		toSearch() {
			axios.get(`${baseUrl}${searchCourseUrl}?keyword=${this.inputContent}`).then(response => {
				this.searchResults=response.data;
			}).catch(error =>{
				alert("发生了错误："+error);
			});
		},
		handleClickItem(index){
			this.$router.push({"name": "Learning", query: {sectionInfo: JSON.stringify(this.searchResults[index])}});
		}
	}
}
</script>

<style scoped>
.container {
	display: flex;
	flex-direction: column;
	width: 50%;
	margin: auto;
	position: relative;
}

.search-area {
	position: absolute;
	top: 10vh;
	left: 10%;
	display: flex;
	flex-direction: row;
	width: 80%;
	height: 40px;
}

.search-input {
	width: 75%;
	margin-right: 5%;
	height: 100%;
}

.search-button {
	width: 20%;
	height: 100%;
	background: linear-gradient(to bottom, rgb(0, 180, 0), rgb(0, 255, 0));
}

.result-list{
	position: relative;
	left:10%;
	top: 18vh;
	display: flex;
	flex-direction: column;
	width: 80%;
	gap: 10px;
}

.result-item {
	height: 50px;
	color: rgb(200, 200, 240);
	font-size: 30px;
	justify-content:20%;
}

@media (max-width: 500px){
	.container{
		width: 100%;
		margin-top: 15vh;
	}
}
</style>